import React from 'react';
import { observer } from 'mobx-react-lite';
import { DobCheckbox } from '@dedalusdiit/dob-components';
import { IWorklistSelectionHelper } from '@/Pages/GenericWorklist/Stores/WorklistSelectionHelper';
import Styles from './SelectionCell.module.scss';

interface SelectionCellProps {
    id: number;
    selectionStore: IWorklistSelectionHelper;
}

const SelectionCell: React.FC<SelectionCellProps> = observer(({ id, selectionStore }) => {
    return (
        <span className={Styles.checkbox}>
            <DobCheckbox checked={selectionStore.isSelected(id)} />
        </span>
    );
});

export default SelectionCell;
